import { Reveal } from "@/components/site/Reveal";
import { GALLERY } from "@/data/property";

export function GalleryBento() {
  return (
    <section id="gallery" className="bg-secondary/40 py-24 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <Reveal>
            <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-accent font-medium mb-5">
              A closer look
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground">
              Room to gather, <em className="italic font-light">room to breathe.</em>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 lg:grid-rows-2 gap-4 md:gap-6 lg:h-[760px]">
          {GALLERY.map((img, i) => (
            <Reveal
              key={img.src}
              delay={i * 0.08}
              className={`group relative overflow-hidden rounded-[1.25rem] ${img.span} h-[300px] md:h-[380px] lg:h-auto`}
            >
              <img
                src={img.src}
                alt={img.alt}
                data-testid={`gallery-image-${i}`}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent opacity-80" />
              <span className="absolute bottom-5 left-6 text-white font-display text-2xl md:text-3xl tracking-tight drop-shadow">
                {img.label}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
